import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6ade2dd6")
const _hoisted_1 = {
  key: 0,
  class: "sticky-breadcrumb"
}
const _hoisted_2 = { class: "sticky-breadcrumb__container" }
const _hoisted_3 = { class: "sticky-breadcrumb__list" }
const _hoisted_4 = {
  key: 0,
  class: "sticky-breadcrumb__item sticky-breadcrumb__item--current"
}
const _hoisted_5 = { class: "sticky-breadcrumb__title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "sticky-breadcrumb__title" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 1,
  class: "breadcrumb-settings-float"
}
const _hoisted_10 = ["title"]
_popScopeId()

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import BreadcrumbSettingsModal from "@/components/modal/BreadcrumbSettingsModal.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();
const { t } = useI18n();
const isSettingsOpen = ref(false);

// Load settings on mount
onMounted(() => {
  store.dispatch("userSettings/loadSettingsFromSession");
});

const breadcrumbPages = computed(() => {
  return store.getters["breadcrumb/lastFivePages"];
});

const isBreadcrumbEnabled = computed(() => {
  return store.getters["userSettings/isBreadcrumbEnabled"];
});

const navigateToPage = (page: any) => {
  const query =
    page.query && Object.keys(page.query).length > 0 ? page.query : undefined;
  router.push({
    path: page.path,
    query
  });
};

// Function to get translated and truncated title
const getDisplayTitle = (page: any): string => {
  let title = page.title;

  // Translate if it's a translation key
  if (page.title.startsWith("breadcrumb.")) {
    title = t(page.title);
  }

  // Truncate to 20 characters
  if (title.length > 20) {
    return title.substring(0, 17) + "...";
  }

  return title;
};

// Function to open settings modal
const openSettings = () => {
  isSettingsOpen.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!

  return (_unref(isBreadcrumbEnabled) && _unref(breadcrumbPages).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbPages), (page, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${page.path}-${page.timestamp}`
              }, [
                (index === _unref(breadcrumbPages).length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      (page.icon)
                        ? (_openBlock(), _createBlock(_component_va_icon, {
                            key: 0,
                            name: page.icon,
                            size: "small",
                            class: "sticky-breadcrumb__icon"
                          }, null, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(getDisplayTitle(page)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: ($event: any) => (navigateToPage(page)),
                      class: "sticky-breadcrumb__item sticky-breadcrumb__item--clickable"
                    }, [
                      (page.icon)
                        ? (_openBlock(), _createBlock(_component_va_icon, {
                            key: 0,
                            name: page.icon,
                            size: "small",
                            class: "sticky-breadcrumb__icon"
                          }, null, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(getDisplayTitle(page)), 1)
                    ], 8, _hoisted_6)),
                (index < _unref(breadcrumbPages).length - 1)
                  ? (_openBlock(), _createBlock(_component_va_icon, {
                      key: 2,
                      name: "chevron_right",
                      size: "small",
                      class: "sticky-breadcrumb__separator"
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("button", {
            onClick: openSettings,
            class: "sticky-breadcrumb__settings",
            title: _ctx.$t('breadcrumbSettings.title')
          }, [
            _createVNode(_component_va_icon, {
              name: "settings",
              size: "small"
            })
          ], 8, _hoisted_8)
        ]),
        _createVNode(BreadcrumbSettingsModal, {
          modelValue: isSettingsOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (isSettingsOpen.value = $event)),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isSettingsOpen.value = false))
        }, null, 8, ["modelValue"])
      ]))
    : (!_unref(isBreadcrumbEnabled))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: openSettings,
            class: "breadcrumb-settings-float__button",
            title: _ctx.$t('breadcrumbSettings.disabled')
          }, [
            _createVNode(_component_va_icon, {
              name: "settings",
              size: "small"
            })
          ], 8, _hoisted_10),
          _createVNode(BreadcrumbSettingsModal, {
            modelValue: isSettingsOpen.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (isSettingsOpen.value = $event)),
            onClose: _cache[3] || (_cache[3] = ($event: any) => (isSettingsOpen.value = false))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
}
}

})